var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.6666 8.81349L23.2399 39.2668L11.9333 27.9602L15.6933 24.2002L23.2399 31.7468L49.9066 5.08016L53.6666 8.81349ZM47.7733 22.2535C48.1199 23.7735 48.3332 25.3735 48.3332 27.0002C48.3332 38.7868 38.7866 48.3335 26.9999 48.3335C15.2133 48.3335 5.66658 38.7868 5.66658 27.0002C5.66658 15.2135 15.2133 5.66683 26.9999 5.66683C31.2133 5.66683 35.1066 6.8935 38.4132 9.00016L42.2532 5.16016C37.9332 2.12016 32.6799 0.333496 26.9999 0.333496C12.2799 0.333496 0.333252 12.2802 0.333252 27.0002C0.333252 41.7202 12.2799 53.6668 26.9999 53.6668C41.7199 53.6668 53.6666 41.7202 53.6666 27.0002C53.6666 23.8268 53.0799 20.7868 52.0666 17.9602L47.7733 22.2535Z",
    fill: "#198754"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.957b9a8f9fece847a4a16320457d1952.svg";
export { ForwardRef as ReactComponent };